/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS also by Adam Jones (http://www.adam-makes-websites.com)
Last Updated: 27/1/25
*/


$(document).ready(function() {
	
  	// append tax/duties statement to selected items in cart
  	$('body').observe('added', '#cart-price .money', function(record) {
		$("#cart-price .money").append('<span class="withVAT"> EXCL. VAT</span>');
  	});
    
  
  	// check for change of every product variant drop down and then check if that new selection is available and update price/sold out msg
    $(document).on('change','.selector-option-Size', function(event){
      updateSoldOutPrice();
    });
  	$(document).on('change','.selector-option-Color', function(event){
      updateSoldOutPrice();
    });
 	$(document).on('change','.selector-option-Colour', function(event){
      updateSoldOutPrice();
    });
    $(document).on('change','.selector-option-Metal', function(event){
      updateSoldOutPrice();
    });
    $(document).on('change','.selector-option-Pearl', function(event){
      updateSoldOutPrice();
    });
  
    // setup popup for out of stock notification
    $(".stockNotifyBtn, #noStockAtAllBtn").fancybox({
		maxWidth	: 800,
		maxHeight	: 600,
		fitToView	: false,
		width		: '70%',
		height		: '70%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none'
	});


    // lightbox for products
   const $dynamicGallery = document.getElementById('product_images');
   const dynamicGallery = lightGallery($dynamicGallery, {
        speed: 300,
        selector: '.image-swap',
        plugins: [lgZoom],
        download: false
    });


    $(document).on('click','.masterImage', function(event){
      dynamicGallery.openGallery();
    });

  
});





$(window).load(function() {
    // add vat to products page, needs doing after page load due to prices in theme loading via ajax
	if ($("body").hasClass("template-product") || $("body").hasClass("template-cart")) {
  		if (window.location.href.indexOf("collections/books") > -1) {
			console.log("Product page thats a book found, not adding VAT msg");
        }else{
          	$(".cart-item-price .money, #cart-total-final-price .money").append('<span class="withVAT"> EXCL. VAT</span>');
			console.log("VAT Msg being added");
        }
 	}
  	
  	markSoldOutVariantsSelect();	// iterate through variants select and add class to sold out ones
    updateSoldOutPrice();			// check if default selected variant is sold out and mark on price if it is
  	
});

// Responsive tables init
$(document).ready(function() {
	$('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');
});

// Wow Animation init
$(document).ready(function() {
  new WOW().init();
});

// Mobile Browser Menu
$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// FancyBox
$(document).ready(function() {
	$(".fancybox").fancybox();
});

$(document).ready(function() {
	$(".fancybox-instagram").fancybox({
		padding : 0
	});
});

// Login Boxes
$("#forgot-password-box").click(function(){
    $("#customer-login").hide();
    $("#recover-password").show();
});

$("#login-box-link").click(function(){
	$("#customer-login").show();
	$("#recover-password").hide();
});

// Drawers
var MOBILE_DRAWER_SIZE = 300,
    DESKTOP_DRAWER_SIZE = 390,
    MOBILE_WIDTH_MAX = 860;

window.slideouts = {};


// Simulate responsiveness of the Drawer component
$(window).resize(function () {
    var is_mobile = document.body.clientWidth < MOBILE_WIDTH_MAX;

    // Disable mobile drawer on desktop
    window.slideouts.left._touch = is_mobile;

    // Resize right drawer based on window width
    var slideout = window.slideouts.right,
        padding = (is_mobile) ? MOBILE_DRAWER_SIZE : DESKTOP_DRAWER_SIZE;
    slideout._translateTo = slideout._padding = padding * slideout._orientation;
    if (slideout._opened) {
        var transform = "translateX(" + (padding * slideout._orientation) + "px)";
        slideout.panel.style.webkitTransform = transform;
        slideout.panel.style.transform = transform;
    }
});



function updateSoldOutPrice(){
  // Created: 8/10/20
  // Updated: 24/4/25
  
  // Desc: Runs on prod page load/variant to check if selected combo is sold out.  Does this by looking at hidden select list that includes '- Sold Out' string.  If it is: 
  // - a 'sold out' is prefixed to the price on screen
  // - also a stock notify btn is added to DOM to allow the user to be notified of when back in stock
  	
  // delete any existing stock notify button
  $(".stockNotifyBtn").remove();
  
  // store selected values in any select boxes
  var currentSize="";
  var currentColour="";
  
  if ($(".selector-option-Size option:selected").val()){
      currentSize=$(".selector-option-Size option:selected").val();
  }
  // only one of the two below will ever be present, never both
  if ($(".selector-option-Color option:selected").val()){
	  currentColour=$(".selector-option-Color option:selected").val();
  }
  if ($(".selector-option-Colour option:selected").val()){
      currentColour=$(".selector-option-Colour option:selected").val();
  }

  console.clear();
  console.log("updateSoldOutPrice() called with selected product values: '"+currentSize+"'/'"+currentColour+"'");
  
  
  
  // first check that there are at least some variants for sale
  var markSoldOut=false;
  var price=0;
  if ($("#ProductSelect-product-template").length){
    // loop all options of hidden main product select and if we find one with a description that matches the visibile dropdown/s assume its current combo and if sold out suffix this to price
    $("#ProductSelect-product-template option").each(function(i){
        
      var currentLabel=$(this).text().trim();
      //console.log("updateSoldOutPrice() determining stock availability against label: '"+currentLabel+"'");
      
      if (currentSize!="" && currentColour!=""){
        
        //console.log("updateSoldOutPrice(): condition 1 for label '"+currentLabel+"'");
        
        if (currentLabel.startsWith(currentSize) && currentLabel.includes(currentColour)){
            if ( currentLabel.includes(" - Sold Out")){
              console.log("updateSoldOutPrice() !!! found SOLD OUT item with matching SIZE + COLOUR (condition 1a): '"+currentColour+"' / '"+currentSize+"' -> "+currentLabel);
              markSoldOut=true;
              price=$(this).data("price");
            }else{
              console.log("updateSoldOutPrice() !!! NOT SOLD OUT (condition 1b): "+currentColour+"/"+currentSize+"!");
            }
        }else if ( isFullMatch(currentLabel, currentColour + " / " + currentSize) || isFullMatch(currentLabel, currentSize + " / " + currentColour) ){
            if ( currentLabel.includes(" - Sold Out")){
              console.log("updateSoldOutPrice() !!! found SOLD OUT item with matching COLOUR + SIZE (condition 1c): '"+currentColour+"' / '"+currentSize+"' -> "+currentLabel);
              markSoldOut=true;
              price=$(this).data("price");
            }else{
              console.log("updateSoldOutPrice() !!! NOT SOLD OUT (condition 1d): '"+currentColour+"' / '"+currentSize+"'");
            }
        }else{
          console.log("updateSoldOutPrice() !!! NO condition match found (condition 1e) for current label '"+currentLabel+"' with '"+currentColour+"' / '"+currentSize+"'");
        }
        
      }else if (currentSize=="" && currentColour!=""){
        //console.log("updateSoldOutPrice(): condition 2 for label '"+currentLabel+"'");
        if (currentLabel.includes(currentColour)){
          if ( currentLabel.includes(" - Sold Out")){
            console.log("updateSoldOutPrice() !!! found SOLD OUT item with matching Colour only (condition 2a): '"+currentColour+"' -> "+currentLabel);
            markSoldOut=true;
            price=$(this).data("price");
          }else{
            console.log("updateSoldOutPrice() !!! NOT SOLD OUT (condition 2b): '"+currentColour+"' / '"+currentSize+"'");
          }
        }
        
      }else if (currentSize!="" && currentColour==""){
        //console.log("updateSoldOutPrice(): condition 3 for label '"+currentLabel+"'");
        if (currentLabel.startsWith(currentSize)){
            if ( currentLabel.includes(" - Sold Out")){
              console.log("updateSoldOutPrice() !!!! found SOLD OUT item with matching Size Only (condition 3a): '"+currentSize+"' -> "+currentLabel);
              markSoldOut=true;
              price=$(this).data("price");
            }else{
              console.log("updateSoldOutPrice() !!! NOT SOLD OUT (condition 3b): '"+currentColour+"' / '"+currentSize+"'");
            }
        }
      }   
    }); // end select loop


    
    if (markSoldOut==true){
      console.log("updateSoldOutPrice() - CONCLUSION: Marking currently selected option ("+currentColour+"-"+currentSize+") as SOLD OUT!");
      
      // PREFIX current price label with SOLD OUT notation
      $("#price-field").html("SOLD OUT - ("+price+")");
      // $(".stockNotifyBtn").remove();
      
      // add email btn
      var prodName=$(".product-description-header").html();
      $("#purchase").after('<span class="btn envyBtn stockNotifyBtn" data-fancybox-type="iframe" href="https://simon.mfs.gg/XOVJ4zu?text_4678='+prodName+'">Please click here to join the waiting list, and be notified when this product is back in stock</span>');
    
    }else{
      
      console.log("updateSoldOutPrice() - CONCLUSION: selected option ("+currentColour+" - "+currentSize+") NOT sold out"); 
      // $(".stockNotifyBtn").remove();
      $("#price-field").append('<span class="withVAT"> EXCL. VAT</span>');
    }
    
  }else{
    console.log("No variants found, nothing to do");
  }
  
      
}



function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escapes special characters
}


function isFullMatch(stringToMatch, thePattern) {
    var escapedPattern = thePattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special regex chars
    // Ensure thePattern matches as a whole word directly adjacent to spaces, slashes, or dashes
    var re = new RegExp("(^|\\s|/|-)"+escapedPattern+"(\\s|/|-|$)", "i");
    return re.test(stringToMatch.trim()) && !new RegExp(`(?:/|-)\\s*\\w+\\s+${escapedPattern}`, "i").test(stringToMatch.trim());
}





function markSoldOutVariantsSelect(){
  	// Created: 8/10/20 : AJ
    // Updated: 13/10/20
	// Adds a class to the variants selector to mark sold out items differently so they can be shaded in another style
  	
  	console.log("Iterating product options looking for sold out...");
  	$("#ProductSelect-product-template option").each(function(i){
      var currentLabel=$(this).text().trim();
      var currentName=$(this).data("name").trim();
      
      // if we have colours explode and get just the size
      if (currentName.includes(" / ")){
        currentName=currentName.split(" / ");
        currentName=currentName[1];
      }
      
      console.log(currentLabel);
      
      if (currentLabel.includes(" - Sold Out")){
        // iterate through envy themes alternative select variants
      	$(".sod_list span").each(function(i){
          var currentEnvyLabel=$(this).text().trim();
          console.log("checking envy select list for same name as this label ("+currentName+"), we found: "+currentEnvyLabel);
          
          if (currentEnvyLabel.includes(currentName)){
            //$(this).css('opacity', '0.4');
            //$(this).append(" - SOLD OUT");
          }else{
            console.log("not included");
          }
        });
      }
    });
	
}



function create_drawer(side, panel, menu, hidden_menu, overlay) {
    var padding = MOBILE_DRAWER_SIZE;
    if (side === 'right' && document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        padding = DESKTOP_DRAWER_SIZE;
    }

    var slideout = new Slideout({
        'panel': panel,
        'menu': menu,
        'padding': padding,
        'tolerance': 70,
        'side': side,
        'touch': false
    });
    var dir = (side === 'right') ? -1 : 1;
    window.slideouts[side] = slideout;
    menu.classList.add('slideout-panel-hidden');

    var $overlay = $(overlay);
    overlay.addEventListener('click', slideout.close.bind(slideout));

    // Handle slide to close
    var touch_start = null;
    overlay.addEventListener('touchstart', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        event.preventDefault();
        touch_start = event.touches[0].pageX;
    });
    overlay.addEventListener('touchmove', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.touches[0].pageX;
        var translate = (dir * padding) - offset;
        if (Math.abs(translate) > padding) {
            translate = (dir * padding);
        }
        panel.style.webkitTransform ='translateX(' + translate + 'px)';
        panel.style.transform ='translateX(' + translate + 'px)';
    });
    overlay.addEventListener('touchend', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.changedTouches[0].pageX;
        if (offset === 0 || Math.abs(offset) > 70) {
            slideout.close(slideout);
        } else {
            panel.style.webkitTransform = 'translateX(' + (dir * padding) + 'px)';
            panel.style.transform = 'translateX(' + (dir * padding) + 'px)';
        }
    });

    slideout.on('beforeopen', function() {
        menu.classList.remove('slideout-panel-hidden');
        hidden_menu.classList.add('slideout-panel-hidden');
        $overlay.fadeIn();
        // document.body.style.overflowY = 'hidden';
        var marginTop = (-document.body.scrollTop) + 'px';
        panel.style.position = 'fixed';
        panel.style.marginTop = marginTop;
    });

    slideout.on('beforeclose', function () {
        $overlay.fadeOut();
        var scrollTop = -parseInt(panel.style.marginTop);
        panel.style.position = '';
        panel.style.marginTop = '';
        document.body.scrollTop = scrollTop;
    });

    slideout.on('close', function() {
        menu.classList.add('slideout-panel-hidden');
        console.log("Closing - in function");
        $('.navigation-button').css('visibility', 'visible');
    });
    slideout.on('translate', function(translated) {
        var hidden = false;
        if (translated === 0) {
            hidden = true;
        } else if (side === 'left') {
            hidden = translated <= 0;
        } else if (side === 'right') {
            hidden = translated >= 0;
        }
        menu.classList.toggle('slideout-panel-hidden', hidden);
        hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
    });

    return slideout;
}



function load_menu_drawer() {
    var main_body = document.querySelector('#main-body');
    var left_menu = document.querySelector('#menu');
    var right_menu = document.querySelector('#cartSlideoutWrapper');
    var overlay = document.querySelector('#slideout-overlay');

    /* Mobile Menu */

    /* Move mobile menu out of section to document body because the slideout
       needs to put it to the sidebar, but it can't be in the body from the beginning
       because it needs section config */
    document.body.appendChild(left_menu);

    var slideoutLeft = create_drawer('left', main_body, left_menu, right_menu, overlay);

    $('.slide-menu-mobile').on('click', function() {
        slideoutLeft.toggle();
        console.log("Menu clicked");
    });

    $('.mobile-menu-close').on('click', function () {
        slideoutLeft.close();
        console.log("Menu closed");
    });

    // Disable mobile drawer on desktop
    if (document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        slideoutLeft._touch = false;
    }

    // Add events for sidebar manipulation from outside
    $(left_menu)
        .on('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft))
        .on('mobile:open', slideoutLeft.open.bind(slideoutLeft))
        .on('mobile:close', slideoutLeft.close.bind(slideoutLeft));

    /* Cart */
    var slideoutRight = create_drawer('right', main_body, right_menu, left_menu, overlay);

    // Toggle button
    $('.slide-menu-cart').on('click', function (e) {
        slideoutRight.toggle();
        // prevent non-ajax basket
        e.preventDefault();
        return false;
    });

    $('.cart-menu-close').on('click', function (e) {
        slideoutRight.close();
    });

    // Add events for sidebar manipulation from outside
    $(right_menu)
        .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
        .on('cart:open', slideoutRight.open.bind(slideoutRight))
        .on('cart:close', slideoutRight.close.bind(slideoutRight));
  
}

$(document).ready(load_menu_drawer);

document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'header') {
        load_menu_drawer();
    } else if (event.detail.sectionId === 'footer') {
        // Shopify doesn't correctly handle scrolling to footer on section change because the section
        // has zero height when it's scrolled to but when it loads it gets out of visible area
        setTimeout(function () {
            // Scroll to the footer element after loading
            document.documentElement.scrollTop = document.body.scrollTop = document.body.clientHeight;
        }, 0);
    }
});


/* PS theme imported content */
$(document).ready(function() {

  // ?
  $('#searchform select, #searchform input[type="checkbox"], #searchform input[type="radio"]').change(function() {
    $(this).closest("form").submit();
  });
  
  // catch open action  of slide out menu
  $('.navigation-button').click(function() {
      console.log("opening");
      $('body').toggleClass('no-scroll');       		
      $(this).toggleClass('visible');  
      $('.navigation-overlay').toggleClass('visible');  
      $('.navigation-button').css('visibility', 'hidden');
         		
  });

  // catch close action of slide out menu
  /*
  $('.sidr-close-icon, #slideout-overlay').click(function () {
      console.log("closing");
      $('.navigation-button').show();
      $('body').toggleClass('no-scroll');       		
      $('.navigation-button').toggleClass('visible');  
      $('.search-overlay').toggleClass('visible');
      $(".search-overlay input[type='text']").focus();
    
  });
  */

  $(document).on('click','#slideout-overlay', function(event){
    console.log("ha");
   });
  
});







(function(d){d.Observe={}})(jQuery);
(function(d,q){var r=function(e,f){f||(f=e,e=window.document);var m=[];d(f).each(function(){for(var l=[],g=d(this),h=g.parent();h.length&&!g.is(e);h=h.parent()){var f=g.get(0).tagName.toLowerCase();l.push(f+":eq("+h.children(f).index(g)+")");g=h}(h.length||g.is(e))&&m.push("> "+l.reverse().join(" > "))});return m.join(", ")};q.path={get:r,capture:function(e,f){f||(f=e,e=window.document);var m=[];d(f).each(function(){var l=-1,g=this;if(this instanceof Text)for(var g=this.parentNode,h=g.childNodes,
f=0;f<h.length;f++)if(h[f]===this){l=f;break}var k=r(e,g),n=d(e).is(g);m.push(function(e){e=n?e:d(e).find(k);return-1===l?e:e.contents()[l]})});return function(e){e=e||window.document;return m.reduce(function(d,f){return d.add(f(e))},d([]))}}}})(jQuery,jQuery.Observe);(function(d,q){var r=function(e){this.original=d(e);this.root=this.original.clone(!1,!0)};r.prototype.find=function(d){return q.path.capture(this.original,d)(this.root)};q.Branch=r})(jQuery,jQuery.Observe);
(function(d,q){var r=function(a,b){var c={};a.forEach(function(a){(a=b(a))&&(c[a[0]]=a[1])});return c},e=r("childList attributes characterData subtree attributeOldValue characterDataOldValue attributeFilter".split(" "),function(a){return[a.toLowerCase(),a]}),f=r(Object.keys(e),function(a){if("attributefilter"!==a)return[e[a],!0]}),m=r(["added","removed"],function(a){return[a.toLowerCase(),a]}),l=d([]),g=function(a){if("object"===typeof a)return a;a=a.split(/\s+/);var b={};a.forEach(function(a){a=
a.toLowerCase();if(!e[a]&&!m[a])throw Error("Unknown option "+a);b[e[a]||m[a]]=!0});return b},h=function(a){return"["+Object.keys(a).sort().reduce(function(b,c){var d=a[c]&&"object"===typeof a[c]?h(a[c]):a[c];return b+"["+JSON.stringify(c)+":"+d+"]"},"")+"]"},t=window.MutationObserver||window.WebKitMutationObserver,k=function(a,b,c,s){this._originalOptions=d.extend({},b);b=d.extend({},b);this.attributeFilter=b.attributeFilter;delete b.attributeFilter;c&&(b.subtree=!0);b.childList&&(b.added=!0,b.removed=
!0);if(b.added||b.removed)b.childList=!0;this.target=d(a);this.options=b;this.selector=c;this.handler=s};k.prototype.is=function(a,b,c){return h(this._originalOptions)===h(a)&&this.selector===b&&this.handler===c};k.prototype.match=function(a){var b=this.options,c=a.type;if(!this.options[c])return l;if(this.selector)switch(c){case "attributes":if(!this._matchAttributeFilter(a))break;case "characterData":return this._matchAttributesAndCharacterData(a);case "childList":if(a.addedNodes&&a.addedNodes.length&&
b.added&&(c=this._matchAddedNodes(a),c.length))return c;if(a.removedNodes&&a.removedNodes.length&&b.removed)return this._matchRemovedNodes(a)}else{var s=a.target instanceof Text?d(a.target).parent():d(a.target);if(!b.subtree&&s.get(0)!==this.target.get(0))return l;switch(c){case "attributes":if(!this._matchAttributeFilter(a))break;case "characterData":return this.target;case "childList":if(a.addedNodes&&a.addedNodes.length&&b.added||a.removedNodes&&a.removedNodes.length&&b.removed)return this.target}}return l};
k.prototype._matchAttributesAndCharacterData=function(a){return this._matchSelector(this.target,[a.target])};k.prototype._matchAddedNodes=function(a){return this._matchSelector(this.target,a.addedNodes)};k.prototype._matchRemovedNodes=function(a){var b=new q.Branch(this.target),c=Array.prototype.slice.call(a.removedNodes).map(function(a){return a.cloneNode(!0)});a.previousSibling?b.find(a.previousSibling).after(c):a.nextSibling?b.find(a.nextSibling).before(c):(this.target===a.target?b.root:b.find(a.target)).empty().append(c);
return this._matchSelector(b.root,c).length?d(a.target):l};k.prototype._matchSelector=function(a,b){var c=a.find(this.selector);b=Array.prototype.slice.call(b);return c=c.filter(function(){var a=this;return b.some(function(b){return b instanceof Text?b.parentNode===a:b===a||d(b).has(a).length})})};k.prototype._matchAttributeFilter=function(a){return this.attributeFilter&&this.attributeFilter.length?0<=this.attributeFilter.indexOf(a.attributeName):!0};var n=function(a){this.patterns=[];this._target=
a;this._observer=null};n.prototype.observe=function(a,b,c){var d=this;this._observer?this._observer.disconnect():this._observer=new t(function(a){a.forEach(function(a){d.patterns.forEach(function(b){var c=b.match(a);c.length&&c.each(function(){b.handler.call(this,a)})})})});this.patterns.push(new k(this._target,a,b,c));this._observer.observe(this._target,this._collapseOptions())};n.prototype.disconnect=function(a,b,c){var d=this;this._observer&&(this.patterns.filter(function(d){return d.is(a,b,c)}).forEach(function(a){a=
d.patterns.indexOf(a);d.patterns.splice(a,1)}),this.patterns.length||this._observer.disconnect())};n.prototype.disconnectAll=function(){this._observer&&(this.patterns=[],this._observer.disconnect())};n.prototype.pause=function(){this._observer&&this._observer.disconnect()};n.prototype.resume=function(){this._observer&&this._observer.observe(this._target,this._collapseOptions())};n.prototype._collapseOptions=function(){var a={};this.patterns.forEach(function(b){var c=a.attributes&&a.attributeFilter;
if(!c&&a.attributes||!b.attributeFilter)c&&b.options.attributes&&!b.attributeFilter&&delete a.attributeFilter;else{var e={},f=[];(a.attributeFilter||[]).concat(b.attributeFilter).forEach(function(a){e[a]||(f.push(a),e[a]=1)});a.attributeFilter=f}d.extend(a,b.options)});Object.keys(m).forEach(function(b){delete a[m[b]]});return a};var p=function(a){this.patterns=[];this._paused=!1;this._target=a;this._events={};this._handler=this._handler.bind(this)};p.prototype.NS=".jQueryObserve";p.prototype.observe=
function(a,b,c){a=new k(this._target,a,b,c);d(this._target);a.options.childList&&(this._addEvent("DOMNodeInserted"),this._addEvent("DOMNodeRemoved"));a.options.attributes&&this._addEvent("DOMAttrModified");a.options.characterData&&this._addEvent("DOMCharacerDataModified");this.patterns.push(a)};p.prototype.disconnect=function(a,b,c){var e=d(this._target),f=this;this.patterns.filter(function(d){return d.is(a,b,c)}).forEach(function(a){a=f.patterns.indexOf(a);f.patterns.splice(a,1)});var g=this.patterns.reduce(function(a,
b){b.options.childList&&(a.DOMNodeInserted=!0,a.DOMNodeRemoved=!0);b.options.attributes&&(a.DOMAttrModified=!0);b.options.characterData&&(a.DOMCharacerDataModified=!0);return a},{});Object.keys(this._events).forEach(function(a){g[a]||(delete f._events[a],e.off(a+f.NS,f._handler))})};p.prototype.disconnectAll=function(){var a=d(this._target),b;for(b in this._events)a.off(b+this.NS,this._handler);this._events={};this.patterns=[]};p.prototype.pause=function(){this._paused=!0};p.prototype.resume=function(){this._paused=
!1};p.prototype._handler=function(a){if(!this._paused){var b={type:null,target:null,addedNodes:null,removedNodes:null,previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null};switch(a.type){case "DOMAttrModified":b.type="attributes";b.target=a.target;b.attributeName=a.attrName;b.oldValue=a.prevValue;break;case "DOMCharacerDataModified":b.type="characterData";b.target=d(a.target).parent().get(0);b.attributeName=a.attrName;b.oldValue=a.prevValue;break;case "DOMNodeInserted":b.type=
"childList";b.target=a.relatedNode;b.addedNodes=[a.target];b.removedNodes=[];break;case "DOMNodeRemoved":b.type="childList",b.target=a.relatedNode,b.addedNodes=[],b.removedNodes=[a.target]}for(a=0;a<this.patterns.length;a++){var c=this.patterns[a],e=c.match(b);e.length&&e.each(function(){c.handler.call(this,b)})}}};p.prototype._addEvent=function(a){this._events[a]||(d(this._target).on(a+this.NS,this._handler),this._events[a]=!0)};q.Pattern=k;q.MutationObserver=n;q.DOMEventObserver=p;d.fn.observe=
function(a,b,c){b?c||(c=b,b=null):(c=a,a=f);return this.each(function(){var e=d(this),f=e.data("observer");f||(f=t?new n(this):new p(this),e.data("observer",f));a=g(a);f.observe(a,b,c)})};d.fn.disconnect=function(a,b,c){a&&(b?c||(c=b,b=null):(c=a,a=f));return this.each(function(){var e=d(this),f=e.data("observer");f&&(a?(a=g(a),f.disconnect(a,b,c)):(f.disconnectAll(),e.removeData("observer")))})}})(jQuery,jQuery.Observe);